module.exports = __webpack_public_path__ + "1-36.png?ccba28e8fdff7c528d50e1620af4731e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1-36.png
// module id = 113
// module chunks = 0